import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login, user, checking } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!checking && user) navigate("/admin", { replace: true });
  }, [user, checking, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-5 font-mono">
      <div className="w-full max-w-md bg-white text-black border-4 border-black hard-shadow-white p-8">
        <Link to="/" className="font-scribble text-4xl block mb-2">LilBrain jr</Link>
        <div className="flex items-center gap-2 mb-8 text-xs uppercase tracking-[0.3em]">
          <Lock size={14} strokeWidth={3} /> admin access only
        </div>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="text-xs uppercase tracking-widest font-bold">email</label>
            <input data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="mt-2 w-full border-2 border-black px-4 py-3 outline-none focus:bg-black focus:text-white transition-colors" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest font-bold">password</label>
            <input data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="mt-2 w-full border-2 border-black px-4 py-3 outline-none focus:bg-black focus:text-white transition-colors" />
          </div>
          {error && <p data-testid="login-error" className="text-sm uppercase border-2 border-black px-3 py-2">{error}</p>}
          <button data-testid="login-submit-btn" type="submit" disabled={loading}
            className="w-full bg-black text-white px-6 py-4 uppercase tracking-widest text-sm border-2 border-black hover:bg-white hover:text-black transition-colors disabled:opacity-50">
            {loading ? "entering..." : "enter the void"}
          </button>
        </form>
      </div>
    </div>
  );
}
